<style lang="scss">
</style>
<template>
    <el-dialog
            :title="title"
            :visible.sync="syncDialog.show"
            append-to-body
            :show-close="!loading"
            :close-on-click-modal="!loading"
            :close-on-press-escape="!loading"
            width="30%">
        <el-form class="my-form">
            <el-form-item label="管理主体" label-width="100px">
                <el-select v-model="form.manageSubjectCode" clearable placeholder="为空同步所有主体">
                    <el-option
                            v-for="item in manageOptions"
                            :key="item.manageSubjectCode"
                            :label="item.manageSubjectName"
                            :value="item.manageSubjectCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <template v-if="syncDialog.sendTime">
                <el-form-item label="选择月" label-width="100px">
                    <el-date-picker
                            value-format="yyyy-MM"
                            v-model="form.syncTime"
                            type="month"
                            placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
            </template>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sendSync" :loading="loading">确 定</el-button>
            </span>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            syncDialog: {},
            title: {
                default: '同步'
            }
        },
        data() {
            return {
                loading: false,
                manageOptions: [],
                form:{
                    manageSubjectCode: '',
                    syncTime: ''
                }
            }
        },
        created() {
            this.$api.post('base/manageSubject/findCanSyncManageSubject', {})
                .then(res => {
                    this.manageOptions = res;
                })
        },
        methods: {
            sendSync() {
                // this.$help.loading();
                this.loading = true;
                this.$api.post(this.syncDialog.syncUrl , this.form)
                    .then(res => {
                        this.$help.success(res.msg);
                        this.syncDialog.show = false;
                        this.$emit('init');
                    })
                    .finally(() => {
                        this.loading = false;
                        //this.$help.loaded();
                    });
            },
        }
    }
</script>
